import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchSellersFilter } from '../../../../actions/sellersActions';
import {
    fetchEstadosLiquidaciones,
    fetchResultadosLiquidaciones,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones,
    updateImporteNovedadResultados,
    removeNovedadResultados
} from '../../../../actions/LiquidacionesActions';
import { getTiposConceptos } from '../../../../actions/tiposActions';
import {
    putConfirmaNovedad,
    putEliminaNovedadFinal,
    getEstadosLiquidaciones,
    putEditaNovedadImporte
} from '../../../../api/axios';
import { DropDownArrow, customStyleFilterWrap, filterSelectMenuPortalProps } from '../../../../template/CustomStyle';
import { toast } from '../../../../utilities/appToast';
import Select from 'react-select';
import NovedadesListItems from './NovedadesListItems';
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios';
import BigSpinner from '../../../General/BigSpinner';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import LiquidacionesFilterCard from '../../shared/LiquidacionesFilterCard';
import LiquidacionesFilterActions from '../../shared/LiquidacionesFilterActions';
import { LiquidacionesBtnCrear, LiquidacionesEmptyState } from '../../shared/LiquidacionesButtons';
import SafeReactPaginate from '../../../General/SafeReactPaginate';

const fechaFiltro = filtroMedioMes();

const estadosSelectStyles = customStyleFilterWrap;

function ListNovedadesWrapper(props) {
    const navigate = useNavigate();
    return <ListNovedades {...props} navigate={navigate} />;
}

class ListNovedades extends React.Component {
    constructor(props) {
        super(props);

        const initialPageSize = Number(props.filtro?.cantidadPagina ?? props.filtro?.tamanoPagina ?? 20) || 20;
        const initialPage = Number(props.filtro?.numeroPagina ?? props.filtro?.page ?? 1) || 1;

        this.state = {
            listaTipoEstados: [],
            isLoadingTipoEstados: false,
            isLoadingTipoConcepto: false,
            isLoadingSellersOptions: false,
            seller: {
                label: props.filtro?.seller?.label ?? "",
                value: props.filtro?.seller?.value ?? ""
            },
            estado: {
                label: props.filtro?.estado?.label ?? "",
                value: props.filtro?.estado?.value ?? ""
            },
            fechaDesde: props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            ordenDeReferencia: {
                label: props.filtro?.ordenDeReferencia?.label ?? "",
                value: props.filtro?.ordenDeReferencia?.value ?? ""
            },
            concepto: {
                label: props.filtro?.concepto?.label ?? "",
                value: props.filtro?.concepto?.value ?? ""
            },
            ordenFecha: props.filtro?.ordenFecha ?? "desc",
            showMobileFilters: typeof window === 'undefined' || window.innerWidth >= 768,
            listaTipoConcepto: [],
            // Paginado
            pageSize: initialPageSize,
            currentPage: initialPage,
            totalPages: 0,
            totalRecords: 0
        };

        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            ordenDeReferencia: { label: "", value: "" },
            concepto: { label: "", value: "" },
            ordenFecha: "desc",
            cantidadPagina: this.state.pageSize,
            numeroPagina: this.state.currentPage
        };
    }

    componentDidMount() {
        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }

    // Actualiza paginado según la respuesta de la API (maneja nombres comunes)
    updatePaginationFromResponse = (value) => {
        if (!value) return;
        const totalPages = Number(value?.totalPaginas ?? value?.totalPages ?? value?.TotalPages ?? 0) || 0;
        const totalRecords = Number(value?.totalRegistros ?? value?.cantidadTotal ?? value?.total ?? value?.Total ?? 0) || 0;
        const page = Number(value?.numeroPagina ?? value?.page ?? value?.pageNumber ?? value?.NumeroPagina ?? 1) || 1;
        const pageSize = Number(value?.tamanoPagina ?? value?.cantidadPagina ?? value?.pageSize ?? this.state.pageSize) || this.state.pageSize;

        this.setState({
            totalPages,
            totalRecords,
            currentPage: page,
            pageSize
        });
    }

    buscarSinFiltro = () => {
        const request = {
            fechaDesde: this.INITIAL_REQUEST.fechaDesde,
            fechaHasta: this.INITIAL_REQUEST.fechaHasta,
            buscaTodo: 1,
            idSeller: 0,
            idEstado: 0,
            ordenDeReferencia: 0,
            idTipoNovedad: 0,
            numeroPagina: 1,
            cantidadPagina: this.state.pageSize
        };

        // Guardar filtro global (con paginado)
        this.props.setFiltroLiquidaciones({ ...this.INITIAL_REQUEST, numeroPagina: 1, cantidadPagina: this.state.pageSize });

        this.props.fetchResultadosLiquidaciones(request)
            .then(value => this.updatePaginationFromResponse(value))
            .catch(() => { /* el action ya gestiona errores */ });
    }

    buscarConFiltro = () => {
        const filtroParams = {
            fechaDesde: this.props.filtro?.fechaDesde ?? this.state.fechaDesde,
            fechaHasta: this.props.filtro?.fechaHasta ?? this.state.fechaHasta,
            seller: this.props.filtro?.seller ?? this.state.seller,
            estado: this.props.filtro?.estado ?? this.state.estado,
            concepto: this.props.filtro?.concepto ?? this.state.concepto,
            ordenDeReferencia: this.props.filtro?.ordenDeReferencia ?? this.state.ordenDeReferencia,
            ordenFecha: this.props.filtro?.ordenFecha ?? this.state.ordenFecha ?? "desc"
        };

        const request = this.buildRequestFromFiltro(filtroParams);
        request.numeroPagina = Number(this.props.filtro?.numeroPagina ?? this.state.currentPage ?? 1);
        request.cantidadPagina = Number(this.props.filtro?.cantidadPagina ?? this.state.pageSize ?? 20);

        this.props.fetchResultadosLiquidaciones(request)
            .then(value => this.updatePaginationFromResponse(value))
            .catch(() => { });

        if (this.props.isFilterClear) this.setLimpiarFiltroFalse();
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    myChangeHandler = (e) => {
        const { name, value } = e.target;
        if (name === "ordenDeReferencia") {
            this.setState({ ordenDeReferencia: { label: value, value: value } });
            return;
        }
        this.setState({ [name]: value });
    }

    mapConceptos = () => {
        if (this.state.isLoadingTipoConcepto || this.state.listaTipoConcepto.length > 0) return;

        this.setState({ isLoadingTipoConcepto: true });
        getTiposConceptos().then(res => {
            const raw = Array.isArray(res?.listaConceptoNovedades)
                ? res.listaConceptoNovedades
                : [];
            const listaAccion = raw.map((tipo) => {
                const idTipo = tipo.idTipoNovedad ?? tipo.IdTipoNovedad ?? 0;
                const label =
                    tipo.idConcepto ?? tipo.IdConcepto
                    ?? tipo.concepto ?? tipo.Concepto
                    ?? tipo.detalleConcepto ?? tipo.DetalleConcepto
                    ?? tipo.descripcionSubTipoNovedad ?? tipo.DescripcionSubTipoNovedad
                    ?? tipo.descripcionSubTipo ?? tipo.DescripcionSubTipo
                    ?? "";
                return { label, value: String(idTipo) };
            });
            this.setState({ listaTipoConcepto: listaAccion, isLoadingTipoConcepto: false });
        }).catch(() => {
            this.setState({ isLoadingTipoConcepto: false });
        });
    };

    selectSearchHandlerConcepto = (options) => {
        const valor = options ? { label: options.label, value: options.value.toString() } : { label: "", value: "" };
        this.setState({ concepto: valor });
    };

    onOrdenFechaChange = (ordenFechaValue) => {
        this.setState({ ordenFecha: ordenFechaValue });
        this.props.setFiltroLiquidaciones({
            ...this.props.filtro,
            ordenFecha: ordenFechaValue
        });
    };

    ordenarLiquidacionesPorFecha = (lista, orden) => {
        if (!Array.isArray(lista) || lista.length === 0) return lista;
        const copia = [...lista];
        const parseFecha = (fechaStr) => {
            if (!fechaStr) return 0;
            if (fechaStr.includes("/")) {
                const [d, m, y] = fechaStr.split("/");
                return new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10)).getTime();
            }
            return new Date(fechaStr).getTime() || 0;
        };
        copia.sort((a, b) => {
            const tsA = parseFecha(a.fechaNovedad);
            const tsB = parseFecha(b.fechaNovedad);
            return orden === "asc" ? tsA - tsB : tsB - tsA;
        });
        return copia;
    };

    buildRequestFromFiltro = (filtro) => {
        const sellerVal = this.state.seller?.value ?? filtro.seller?.value ?? "";
        const estadoVal = this.state.estado?.value ?? filtro.estado?.value ?? "";
        const ordenRef = this.state.ordenDeReferencia?.value ?? filtro.ordenDeReferencia?.value ?? "";
        const conceptoVal = this.state.concepto?.value ?? filtro.concepto?.value ?? "";

        const idSeller = sellerVal === "" ? 0 : Number.parseInt(sellerVal, 10);
        const idEstado = estadoVal === "" ? 0 : Number.parseInt(estadoVal, 10);
        const ordenDeReferencia = ordenRef === "" ? 0 : Number.parseInt(ordenRef, 10) || 0;
        const idTipoNovedad = conceptoVal === "" ? 0 : Number.parseInt(conceptoVal, 10);
        const buscaTodo =
            idSeller === 0 &&
            idEstado === 0 &&
            ordenDeReferencia === 0 &&
            idTipoNovedad === 0
                ? 1
                : 0;

        return {
            fechaDesde: filtro.fechaDesde,
            fechaHasta: filtro.fechaHasta,
            buscaTodo,
            idSeller,
            idEstado,
            ordenDeReferencia,
            idTipoNovedad
        };
    };

    onSubmit = (event) => {
        event.preventDefault();

        const { fechaDesde, fechaHasta } = this.state;

        if (fechaDesde === "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }
        if (fechaHasta === "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        const setFiltroParams = {
            fechaDesde,
            fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            ordenDeReferencia: this.state.ordenDeReferencia,
            concepto: this.state.concepto,
            ordenFecha: this.state.ordenFecha,
            numeroPagina: 1,
            cantidadPagina: this.state.pageSize
        };

        this.props.setFiltroLiquidaciones(setFiltroParams);

        const request = this.buildRequestFromFiltro(setFiltroParams);
        request.numeroPagina = 1;
        request.cantidadPagina = this.state.pageSize;

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchResultadosLiquidaciones(request)
            .then(value => this.updatePaginationFromResponse(value))
            .catch(() => { });

        this.setLimpiarFiltroFalse();
    }

    onClear = (e) => {
        e.preventDefault();
        this.setState(prev => ({ ...prev, ...this.INITIAL_REQUEST }));
        this.buscarSinFiltro();
    };

    refreshCurrentResults = () => {
        const filtroActual = {
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            ordenDeReferencia: this.state.ordenDeReferencia,
            concepto: this.state.concepto,
            ordenFecha: this.state.ordenFecha,
            numeroPagina: this.state.currentPage,
            cantidadPagina: this.state.pageSize
        };

        const request = this.buildRequestFromFiltro(filtroActual);
        request.numeroPagina = this.state.currentPage;
        request.cantidadPagina = this.state.pageSize;
        request.buscaTodo =
            request.idSeller === 0 &&
            request.idEstado === 0 &&
            request.ordenDeReferencia === 0 &&
            request.idTipoNovedad === 0
                ? 1
                : 0;

        this.props.setFiltroLiquidaciones(filtroActual);

        return this.props.fetchResultadosLiquidaciones(request)
            .then(value => {
                this.updatePaginationFromResponse(value);
                return value;
            });
    }

    confirmarNovedades = (idNovedades) => {
        const data = { id: idNovedades };
        putConfirmaNovedad(data)
            .then(() => {
                return this.refreshCurrentResults();
            })
            .then(() => {
                toast.success("Las novedades fueron confirmadas con éxito");
            })
            .catch(() => toast.error("No pudimos confirmar la novedad"));
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        const valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        const valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    editarNovedad = (idNovedad, nuevoImporte) => {
        const datos = { idNovedad, Importe: nuevoImporte };
        putEditaNovedadImporte(datos)
            .then(() => {
                this.props.updateImporteNovedadResultados({ idNovedad, importe: nuevoImporte });
                toast.success("El importe fue actualizado con éxito.");
            })
            .catch(err => {
                const errores = err?.response?.data?.errores;
                if (Array.isArray(errores))
                    errores.forEach(error => toast.error(error.item2));
                else
                    toast.error("No pudimos editar el importe de esta novedad");
            });
    }

    eliminarNovedad = (idNovedad) => {
        const datos = { idsNovedades: [Number.parseInt(idNovedad, 10)] };
        let mensajeExito = "La novedad fue eliminada con éxito.";
        putEliminaNovedadFinal(datos)
            .then((response) => {
                const mensajeBackend = response?.data?.mensajen;
                if (typeof mensajeBackend === "string" && mensajeBackend.trim() !== "") {
                    mensajeExito = mensajeBackend;
                }
                this.props.removeNovedadResultados({ idNovedad });
                this.setState((prevState) => ({
                    totalRecords: Math.max(0, (Number(prevState.totalRecords) || 0) - 1)
                }));
                toast.success(mensajeExito);
            })
            .catch(err => {
                const errores = err?.response?.data?.errores;
                if (Array.isArray(errores))
                    errores.forEach(error => toast.error(error.item2));
                else
                    toast.error("No pudimos eliminar la novedad");
            });
    }

    goToNuevaNovedad = () => {
        this.props.navigate("/Novedades/Nueva");
    }

    mapSellers = async () => {
        if (this.state.isLoadingSellersOptions) return;
        this.setState({ isLoadingSellersOptions: true });

        try {
            await this.props.fetchSellersFilter({ Descripcion: "", Page: 1, PageSize: 100 });
        } finally {
            this.setState({ isLoadingSellersOptions: false });
        }
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.setState({ isLoadingSellersOptions: true });
            this.props.fetchSellersFilter({ Descripcion: descripcion, Page: 1, PageSize: 100 }).finally(() => {
                this.setState({ isLoadingSellersOptions: false });
            });
        }
        return descripcion;
    }

    mapEstados = () => {
        if (this.state.isLoadingTipoEstados || this.state.listaTipoEstados.length > 0) return;

        this.setState({ isLoadingTipoEstados: true });
        getEstadosLiquidaciones().then(res => {
            const raw = Array.isArray(res?.listadoEstadosNovedades) ? res.listadoEstadosNovedades :
                Array.isArray(res?.estados) ? res.estados : [];
            const listaEstados = raw.map((tipo) => ({
                label: tipo.descripcion ?? tipo.Descripcion ?? "",
                value: (tipo.idEstado ?? tipo.IdEstado ?? "").toString()
            }));
            this.setState({ listaTipoEstados: listaEstados, isLoadingTipoEstados: false });
        }).catch(() => {
            this.setState({ isLoadingTipoEstados: false });
        });
    }

    // ReactPaginate handler
    handlePageClick = (data) => {
        const selectedPage = data.selected + 1; // ReactPaginate 0-based
        const filtroParams = {
            fechaDesde: this.props.filtro?.fechaDesde ?? this.state.fechaDesde,
            fechaHasta: this.props.filtro?.fechaHasta ?? this.state.fechaHasta,
            seller: this.props.filtro?.seller ?? this.state.seller,
            estado: this.props.filtro?.estado ?? this.state.estado,
            concepto: this.props.filtro?.concepto ?? this.state.concepto,
            ordenDeReferencia: this.props.filtro?.ordenDeReferencia ?? this.state.ordenDeReferencia,
            ordenFecha: this.props.filtro?.ordenFecha ?? this.state.ordenFecha
        };
        const request = this.buildRequestFromFiltro(filtroParams);
        request.numeroPagina = selectedPage;
        request.cantidadPagina = this.state.pageSize;

        // Guardar página en filtro global
        this.props.setFiltroLiquidaciones({
            ...this.props.filtro,
            numeroPagina: selectedPage,
            cantidadPagina: this.state.pageSize
        });

        this.props.fetchResultadosLiquidaciones(request)
            .then(value => this.updatePaginationFromResponse(value))
            .catch(() => { });
    }

    render() {
        let listaSellers = Array.isArray(this.props.filteredSellers)
            ? this.props.filteredSellers.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];

        if (listaSellers.length > 0 && listaSellers[0]?.value !== "") {
            listaSellers = [{ value: "", label: "Todos" }, ...listaSellers];
        }

        const liquidaciones = Array.isArray(this.props.liquidaciones) ? this.props.liquidaciones : [];
        const ordenFecha = this.state.ordenFecha ?? "desc";
        const liquidacionesOrdenadas = this.ordenarLiquidacionesPorFecha(liquidaciones, ordenFecha);
        const noOptionsMessage = () => 'Sin opciones';
        const loadingOptionsMessage = () => 'Cargando...';

        const pageCount = this.state.totalPages || (this.state.pageSize ? Math.ceil(this.state.totalRecords / this.state.pageSize) : 0);
        const forcePage = Math.max(0, (this.state.currentPage || 1) - 1);

        return (
            <div className="container gestion-liquidaciones liquidaciones-modulo">
                <LiquidacionesPageHeader
                    title="Gestión de novedades"
                    subtitle="Administración y búsqueda de novedades de liquidación."
                    actions={(
                        <LiquidacionesBtnCrear onClick={this.goToNuevaNovedad}>
                            Crear novedad
                        </LiquidacionesBtnCrear>
                    )}
                />

                <div hidden={!this.state.showMobileFilters}>
                    <form className="form-horizontal form-material gestion-liquidaciones-form" onSubmit={this.onSubmit} onReset={this.onClear}>
                    <LiquidacionesFilterCard
                        actions={(
                            <LiquidacionesFilterActions disabled={this.props.isLoadingLiquidaciones} />
                        )}
                    >
                            <div className="row g-3 align-items-end">
                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Desde</p>
                                    <input type="date" className="form-control" name="fechaDesde" onChange={this.myChangeHandler} value={this.state.fechaDesde} />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Hasta</p>
                                    <input type="date" name="fechaHasta" className="form-control" onChange={this.myChangeHandler} value={this.state.fechaHasta} />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Seller</p>
                                    <Select
                                        value={this.state.seller}
                                        options={listaSellers}
                                        onChange={this.selectSearchHandlerLiquidacionesSeller}
                                        onMenuOpen={this.mapSellers}
                                        onInputChange={this.onSelectSearchInputSellers}
                                        styles={estadosSelectStyles}
                                        {...filterSelectMenuPortalProps}
                                        isLoading={this.state.isLoadingSellersOptions}
                                        loadingMessage={loadingOptionsMessage}
                                        noOptionsMessage={noOptionsMessage}
                                        components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Estados</p>
                                    <Select
                                        value={this.state.estado}
                                        options={this.state.listaTipoEstados}
                                        onChange={this.selectSearchHandlerLiquidacionesEstado}
                                        onMenuOpen={this.mapEstados}
                                        styles={estadosSelectStyles}
                                        {...filterSelectMenuPortalProps}
                                        isLoading={this.state.isLoadingTipoEstados}
                                        loadingMessage={loadingOptionsMessage}
                                        noOptionsMessage={noOptionsMessage}
                                        components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                    />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Orden de referencia</p>
                                    <input type="number" className="form-control" name="ordenDeReferencia" min={0} onChange={this.myChangeHandler} value={this.state.ordenDeReferencia?.value ?? ""} />
                                </div>

                                <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                                    <p className="gestion-liquidaciones-filtro-label mb-0">Concepto</p>
                                    <Select
                                        value={this.state.concepto}
                                        options={this.state.listaTipoConcepto}
                                        onChange={this.selectSearchHandlerConcepto}
                                        onMenuOpen={this.mapConceptos}
                                        styles={estadosSelectStyles}
                                        {...filterSelectMenuPortalProps}
                                        isLoading={this.state.isLoadingTipoConcepto}
                                        loadingMessage={loadingOptionsMessage}
                                        noOptionsMessage={noOptionsMessage}
                                        components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                    />
                                </div>
                            </div>
                    </LiquidacionesFilterCard>
                    </form>
                </div>

                <div className="mobile-filter-toggle-wrap d-md-none">
                    <button
                        type="button"
                        className="btn btn-sm btn-light border mobile-filter-toggle"
                        onClick={() => this.setState((state) => ({ showMobileFilters: !state.showMobileFilters }))}
                        aria-expanded={this.state.showMobileFilters}
                    >
                        <i className={`fa ${this.state.showMobileFilters ? 'fa-chevron-up' : 'fa-filter'}`} />
                        <span>{this.state.showMobileFilters ? 'Ocultar filtros' : 'Filtrar novedades'}</span>
                    </button>
                </div>

                {
                    this.props.isLoadingLiquidaciones ? (
                        <div className="card shadow-sm border-0">
                            <div className="card-body py-5"><div className="d-flex justify-content-center"><BigSpinner message="Cargando novedades..." /></div></div>
                        </div>
                    ) : liquidaciones.length === 0 ? (
                        <LiquidacionesEmptyState>
                            No se encontraron resultados para los filtros seleccionados
                        </LiquidacionesEmptyState>
                    ) : (
                        <NovedadesListItems
                            liquidaciones={liquidacionesOrdenadas}
                            confirmarNovedadesFunction={this.confirmarNovedades}
                            editarNovedadFunction={this.editarNovedad}
                            eliminarNovedadFunction={this.eliminarNovedad}
                            ordenFecha={ordenFecha}
                            onOrdenFechaChange={this.onOrdenFechaChange}
                        />
                    )
                }

                <div className="gestion-liquidaciones-pagination-wrap">
                    <SafeReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={forcePage}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const lr = state.liquidaciones?.lista_resultados_liquidaciones;
    const liquidaciones =
        Array.isArray(lr) ? lr :
            (Array.isArray(lr?.novedades) ? lr.novedades :
                (Array.isArray(lr?.elementos) ? lr.elementos :
                    (Array.isArray(lr?.content) ? lr.content : [])));
    return ({
        tipoUsuario: state.general.tipoUsuario,
        isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
        liquidaciones,
        filteredSellers: state.sellers.filteredSellers,
        filtro: state.liquidaciones.filtro,
        emptyFilters: state.general.limpiar,
        isFilterClear: state.general.limpiar.liquidaciones,
    });
};

export default connect(mapStateToProps, {
    limpiarLiquidacionesBusqueda,
    fetchSellersFilter,
    fetchResultadosLiquidaciones,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    updateImporteNovedadResultados,
    removeNovedadResultados,
    limpiarFiltros
})(ListNovedadesWrapper);
